import { AxiosInstance } from 'axios';

import { toResponse } from '../../genericToResponse';
import { cancellable } from '../../cancellable';

export interface ITargetCheckResponse {
  httpCode: string;
  redirects: string[];
  displayMessage: string;
}

export default (api: AxiosInstance, url: string) => (targetUrl: string) => {
  return cancellable<ITargetCheckResponse>(
    (cancelOptions: any) =>
      api.post(
        url,
        {
          url: targetUrl,
        },
        cancelOptions
      ),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/link/targetCheck/url.ts